import { SideNavigation } from "@ui/organisms/SideNavigation/SideNavigation";
import { TopNavigation } from "@ui/organisms/TopNavigation/TopNavigation";
import * as React from "react";

import styles from "./PortalTemplate.module.scss";

import { PortalContext } from "@/context/PortalContext";
import { useCustomers } from "@/hooks/Customer";
import { Customer } from "@/services/api";
import { PortalMessages } from "@/components/UI/organisms/PortalMessages/PortalMessages";
import { Loading } from "@/components/UI/molecules/Loading/Loading";
export interface IPortalTemplateProps {
	children?: React.ReactNode[] | React.ReactNode;
	showSideNavigation?: boolean;
	showCustomerPicker?: boolean;
	requireCustomerForBody?: boolean;
}

export function PortalTemplate(props: IPortalTemplateProps) {
	const { data: customers, isLoading } = useCustomers();
	const [selectedCustomerId, setSelectedCustomerId] = React.useState<string | null | undefined>(
		() => sessionStorage.getItem("selected-customer-id")
	);

	React.useEffect(() => {
		sessionStorage.setItem("selected-customer-id", selectedCustomerId ?? "");
	}, [selectedCustomerId]);

	React.useEffect(() => {
		if (!!customers?.length) {
			setSelectedCustomerId(
				(selectedCustomerId) =>
					customers.find((i) => selectedCustomerId === i.id)?.id ?? customers[0].id
			);
		}
	}, [customers]);

	return (
		<PortalContext.Provider
			value={{
				pagePrefix: "PCS: ",
				selectedCustomerId,
				setSelectedCustomerId,
			}}>
			<div className={styles.portalTemplate}>
				<div className={styles.topNav}>
					<TopNavigation showCustomerPicker={props.showCustomerPicker} />
				</div>
				<div className={styles.main}>
					<div className={styles.mainInner}>
						{props.showSideNavigation && (
							<div className={styles.sideNav}>
								<SideNavigation />
							</div>
						)}

						{!customers?.length && isLoading && !!props.requireCustomerForBody && (
							<div className={styles.body}>
								<Loading></Loading>
							</div>
						)}
						{(!props.requireCustomerForBody || !!customers?.length) && (
							<div className={styles.body}>
								<PortalMessages></PortalMessages>
								{props.children}
							</div>
						)}
					</div>
				</div>
			</div>
		</PortalContext.Provider>
	);
}
